import { z } from 'zod';

const targetSchema = z.object({
  path: z.string().min(1),
  encoding: z.enum(['scalar', 'array', 'address_list']).default('scalar'),
}).strict();

const operationSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('read') }).strict(),
  z.object({ kind: z.literal('bulk'), operation_key: z.string().min(1) }).strict(),
  z.object({ kind: z.literal('indirect'), operation_key: z.string().min(1) }).strict(),
  z.object({
    kind: z.literal('single'),
    operation_key: z.string().min(1),
    targets: z.array(targetSchema),
    creates_target: z.boolean().default(false),
    selector_paths: z.array(z.string().min(1)).default([]),
  }).strict(),
  z.object({
    kind: z.literal('variable'),
    operation_key: z.string().min(1),
    targets: z.array(targetSchema).min(1),
    selector_paths: z.array(z.string().min(1)).default([]),
  }).strict(),
]);

export const paOperationSemanticsSchema = z.discriminatedUnion('kind', [
  ...operationSchema.options,
  z.object({
    kind: z.literal('actions'),
    action_path: z.string().min(1),
    operations: z.record(operationSchema),
  }).strict(),
]);

export type PaOperationSemantics = z.infer<typeof paOperationSemanticsSchema>;